// extracted by mini-css-extract-plugin
module.exports = {"buttons":"InvestMarketsInvest_buttons__kKQDk","title":"InvestMarketsInvest_title__QCYaV"};